function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define(["exports"], n) : n((e = e || self).DJForthUtilities = {});
}(this, function (e) {
  "use strict";

  function r(e) {
    return e instanceof Element;
  }

  function u(r) {
    for (var e = arguments.length, o = new Array(1 < e ? e - 1 : 0), n = 1; n < e; n++) {
      o[n - 1] = arguments[n];
    }

    return r.length <= o.length ? r.apply(void 0, o) : function () {
      for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
        n[t] = arguments[t];
      }

      return u.apply(void 0, [r].concat(o, n));
    };
  }

  e.checkElements = function () {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
      n[t] = arguments[t];
    }

    return n.reduce(function (e, n) {
      return e ? r(n) : e;
    }, !0);
  }, e.curry = u, e.isElement = r, e.parseBoolean = function (e) {
    return /true|false/.test(e) ? "true" === e : null;
  }, e.parseNumber = function (e) {
    return /^-?\d*\.?\d+$/.test(e) ? parseFloat(e, 10) : null;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});